import { createIcon } from '@chakra-ui/react'

export const TCYIcon = createIcon({
  displayName: 'TCYIcon',
  path: (
    <g>
      <path
        d='M11.9998 1.01544C18.0663 1.01544 22.9849 5.93328 22.9851 11.9998C22.9851 18.0665 18.0664 22.9852 11.9998 22.9852C5.93322 22.985 1.01538 18.0664 1.01538 11.9998C1.01556 5.93339 5.93333 1.01562 11.9998 1.01544Z'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M8.29705 9.27469C8.0729 9.13578 8.06523 8.81224 8.2826 8.663L14.9457 4.09128C15.1686 3.97154 15.4417 3.99513 15.6385 4.15115C15.8284 4.30186 15.9148 4.55108 15.86 4.78909L12.3535 11.5129C12.2954 11.6244 12.155 11.6627 12.0483 11.5967L8.29764 9.27469H8.29705Z'
        fill='currentColor'
      />
      <path
        d='M12.4044 11.7772C12.3039 11.7176 12.1744 11.7491 12.1127 11.8482L7.70589 18.9254C7.54987 19.2395 7.62715 19.6144 7.88079 19.8244C8.09255 19.9998 8.39603 20.0343 8.65616 19.9134C8.66855 19.9078 8.68034 19.9007 8.69155 19.8928L16.1905 14.7247C16.4468 14.548 16.4338 14.1652 16.166 14.0065L12.4047 11.7769L12.4044 11.7772Z'
        fill='currentColor'
      />
    </g>
  ),
  viewBox: '0 0 24 24',
})
